export const getExpensesQuery = (params) => {
    let defaultParams = {
        propertyIds:[], unitIds:[], expenseIds:[], startDate: null, searchText: "",
        endDate: null, minAmount:0, maxAmount:0, status:[], offset:""
    };
    let combinedParams = {...defaultParams, ...params};
    const { propertyIds, unitIds, expenseIds, startDate, searchText,
        endDate, minAmount, maxAmount, status, offset 
    } = combinedParams;

    const query = `
    query{
        expenses(
            propertyIds: ${JSON.stringify(propertyIds)}, 
            unitIds: ${JSON.stringify(unitIds)},
            expenseIds:${JSON.stringify(expenseIds)},
            startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))}, 
            endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))},
            status: ${JSON.stringify(status)},
            minAmount: ${JSON.stringify(minAmount)},
            maxAmount: ${JSON.stringify(maxAmount)},
            searchText: ${JSON.stringify(searchText)},
            offset: ${JSON.stringify(offset)},
            limit: 50
        ){
          previous
          next
          summary{
            header
            body
            footer
          }
          expenses{
            id
            customerAccount{
              id
            }
            property{
              id
              name
            }
            unit{
              id
              unitName
            }
            amount 
            paymentMethod
            category
            status
            creditNote
            notes 
            lastUpdated
            expenseDate
            maintenanceId
            author{
              id
            }
            upload{
              id
              file
            }
          }
        }
      }
    `;
    return query;
}  


export const addExpenseMutation = ( propertyId, unitId, amount, 
    paymentMethod, category, notes, creditNote,
    status, expenseDate,  maintenanceId
  ) => {
    let propertyStr = "";
    if(propertyId){
      propertyStr = `propertyId: ${JSON.stringify(propertyId)},`;
    }  
    let unitStr = "";
    if(unitId){ 
      unitStr = `unitId: ${JSON.stringify(unitId)},`;
    }
    const mutation = `
        mutation ($file: Upload){
            addExpense(
              ${propertyStr} ${unitStr} amount:${amount}, 
              paymentMethod: "${paymentMethod}", category:"${category}", 
              notes:${JSON.stringify(notes)}, creditNote:${creditNote}, status: "${status}", 
              expenseDate:"${expenseDate}", fileUpload: $file, maintenanceId: ${JSON.stringify(maintenanceId)}
            ){
                error{
                    code
                    message
                }
                expense{
                    id
                    customerAccount{
                        id
                    }
                    property{
                        id
                    }
                    unit{
                        id
                    }
                    amount
                    paymentMethod
                    category
                    status
                    creditNote
                    notes
                    lastUpdated
                    expenseDate
                    maintenanceId
                    author{
                        id
                    }
                    upload {
                      id
                      file
                    }
                }
            }
        }`;
    return mutation;
}
 

export const updateExpenseMutation = (
    expenseId, 
    params={ 
        propertyId: "", unitId: "", amount: "", paymentMethod: "", 
        category: "", notes: "", status: "", expenseDate:"",
        updateFile: false 
      }
  ) => {
        const { 
            propertyId, unitId, amount, paymentMethod, 
            category, notes, creditNote, 
            status, expenseDate, updateFile
        } = params;
        let propertyStr = "";
        if(propertyId){
          propertyStr = `propertyId: ${JSON.stringify(propertyId)}, `;
        }  
        let unitStr = "";
        if(unitId){ 
          unitStr = `unitId: ${JSON.stringify(unitId)}, `;
        }
        const mutation = `
            mutation ($file: Upload){
              updateExpense(
                expenseId: ${JSON.stringify(expenseId)}, ${propertyStr} ${unitStr}
                amount:${amount}, paymentMethod: "${paymentMethod}", 
                category:"${category}", notes:${JSON.stringify(notes)}, creditNote:${creditNote}, 
                status: "${status}", expenseDate:"${expenseDate}",
                updateFile: ${updateFile}, fileUpload: $file
              ){
                error{
                  code
                  message
                }
                expense{
                  id
                  customerAccount{
                      id
                  }
                  property{
                      id
                  }
                  unit{
                      id
                  }
                  amount
                  paymentMethod
                  category
                  status
                  creditNote
                  notes
                  lastUpdated
                  expenseDate
                  maintenanceId
                  author{
                      id
                  }
                  upload{
                    id
                    file
                  }
                }
            }
          } 
    `;
    return mutation;
}
  

export const deleteExpenseMutation = (expenseId) => {
    const mutation = `
        mutation{
            deleteExpense(expenseId: ${JSON.stringify(expenseId)}){
            error{
              code
              message
            }
            success
        }
        }
    `;
    return mutation;
}